import appStore from 'store';
import api from './api';

const store = {

    namespaced: true,
    state: {
        tradeRangeList: [],
        tradeFristRangeList: [],
        totalCount: 0,
    },
    mutations: {
        setTradeRangeList(state, payload) {
            state.tradeRangeList = payload;
        },
        setTotalCount(state, payload) {
            state.totalCount = payload;
        },
        setTradeFristRangeList(state, payload) {
            state.tradeFristRangeList = payload;
        }
    },
    actions: {
        findTradeRangeList({ commit }, data) {
            api.listTradeRange(data).then(response => {
                commit('setTotalCount', response.data.length);
                let page = data.page,
                    size = data.size,
                    nowTotal = page * size,
                    preTotal = 1;
                if (page != 1) {
                    preTotal = (page - 1) * size + 1
                }
                if (response.data.length <= 10) {
                    commit('setTradeRangeList', response.data);
                } else {
                    commit('setTradeRangeList', response.data.slice(preTotal - 1, nowTotal));
                }
            })
        },
        findTradeFirstRangeList({ commit }, data) {
            api.listTradeRange(data).then(response => {
                commit('setTradeFristRangeList', response.data);
            })
        }
    }
}

appStore.registerModule('tradeRange', store);